import { communityTrpc } from '@org/clients/community';
import { TrendingPosts, type TrendingPostsProps } from './trending-posts';

export interface ConnectedTrendingPostsProps
  extends Omit<TrendingPostsProps, 'posts' | 'isLoading'> {
  limit?: number;
  withinDays?: number;
  /**
   * Origin to prefix the community-relative post hrefs with (e.g. the
   * community app URL when rendering from another app). Empty = same origin.
   */
  hrefBase?: string;
}

export function ConnectedTrendingPosts({
  limit = 5,
  withinDays = 7,
  hrefBase = '',
  ...rest
}: ConnectedTrendingPostsProps) {
  const { data, isLoading } = communityTrpc.posts.trending.useQuery(
    { limit, withinDays },
    { staleTime: 60_000 }
  );

  const posts = hrefBase
    ? (data ?? []).map((post) => ({ ...post, href: `${hrefBase}${post.href}` }))
    : data ?? [];

  return (
    <TrendingPosts
      posts={posts}
      isLoading={isLoading}
      {...rest}
    />
  );
}
